/**
 * The pure half of several gyms on the device (`D202`).
 */
import {
  type GymListOutput,
  MAX_GYM_NAME_LENGTH,
} from "@repo/contract/training";

export const MAX_NAME = MAX_GYM_NAME_LENGTH;

/** What the server will accept as a name, so Save is disabled before a 422. */
export function validGymName(name: string): boolean {
  const trimmed = name.trim();
  return trimmed.length > 0 && trimmed.length <= MAX_NAME;
}

/**
 * The readiness chips appear only when there is a choice to make: two or
 * more gyms. One gym is the equipment in effect already, and a row with one
 * chip in it asks a question that has one answer.
 */
export function offersGymChoice(
  list: GymListOutput | null | undefined
): boolean {
  return (list?.gyms.length ?? 0) >= 2;
}

/**
 * The gym the chips mark: the one switched to most recently, as the server
 * says — but only while its list is still what is in effect. A checklist
 * edited by hand since then is no longer that gym, and marking it would say
 * the plan reads machines it does not.
 */
export function gymInEffect(
  list: GymListOutput | null | undefined,
  inEffect: readonly number[] | null | undefined
): string | null {
  const current = list?.gyms.find((gym) => gym.id === list.currentGymId);
  if (current === undefined || inEffect === null || inEffect === undefined) {
    return current?.id ?? null;
  }
  const held = [...inEffect].sort((a, b) => a - b).join(",");
  const saved = [...current.equipmentIds].sort((a, b) => a - b).join(",");
  return held === saved ? current.id : null;
}
